
import pagenotfound from '../../../src/images/pagenotfound.png';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import './index.css';

const PageNotFound = () => {
  const history = useHistory();
  const { t } = useTranslation();

  const redirectToHome = () => {
    history.push('/');
  };

  return (
    <div className="page-not-found">
      <div className="page-not-found-content">
        <div className="page-not-found-titule">
          <h1>{t('Ops! Página não encontrada')}</h1>
          <p>
            {t('A página que você está procurando não foi encontrada. Tente acessar outro link ou volte à página inicial.')}
          </p>
          <button onClick={redirectToHome}>
            {t('Voltar à página inicial')}
          </button>
        </div>
        <div className="page-not-found-image">
          <img src={pagenotfound} alt="Pagina não encontrada" />
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;